import { EnumOption } from "./enum-option"

export const RelationshipType = {
    Aunt: 0,
    BiologicalChild: 1,
    Brother: 2,
    BrotherInLaw: 3,
    Caregiver: 4,
    Child: 5,
    CommonLawPartner: 6,
    Cousin: 7,
    Daughter: 8,
    DaughterInLaw: 9,
    DeFacto: 10,
    DomesticPartner: 11,
    ExHusband: 12,
    ExSpouse: 13,
    ExWife: 14,
    ExCommonLawPartner: 15,
    Father: 16,
    FatherInLaw: 17,
    FianceOrFiancee: 18,
    Granddaughter: 19,
    Grandfather: 20,
    Grandmother: 21,
    Grandson: 22,
    HalfBrother: 23,
    HalfSister: 24,
    HostingFamily: 25,
    Husband: 26,
    LawfulPartnerOrCoHabitant: 27,
    LegalGuardian: 28,
    LegallyAdoptedChild: 29,
    Maid: 30,
    Mother: 31,
    MotherInLaw: 32,
    Nephew: 33,
    Niece: 34,
    Other: 35,
    Parent: 36,
    Sibling: 37,
    SignificantOther: 38,
    Sister: 39,
    SisterInLaw: 40,
    Son: 41,
    SonInLaw: 42,
    Spouse: 43,
    Stepbrother: 44,
    Stepchild: 45,
    Stepdaughter: 46,
    Stepfather: 47,
    Stepmother: 48,
    Stepsister: 49,
    Stepson: 50,
    Uncle: 51,
    Ward: 52,
    Wife: 53,
}

export const RelationshipTypeList: EnumOption[] = [
    { value: RelationshipType.Aunt, label: 'Aunt' },
    { value: RelationshipType.BiologicalChild, label: 'Biological child' },
    { value: RelationshipType.Brother, label: 'Brother' },
    { value: RelationshipType.BrotherInLaw, label: 'Brother in Law' },
    { value: RelationshipType.Caregiver, label: 'Caregiver' },
    { value: RelationshipType.Child, label: 'Child' },
    { value: RelationshipType.CommonLawPartner, label: 'Common Law Partner' },
    { value: RelationshipType.Cousin, label: 'Cousin' },
    { value: RelationshipType.Daughter, label: 'Daughter' },
    { value: RelationshipType.DaughterInLaw, label: 'Daughter in Law' },
    { value: RelationshipType.DeFacto, label: 'De Facto' },
    { value: RelationshipType.DomesticPartner, label: 'Domestic Partner' },
    { value: RelationshipType.ExHusband, label: 'Ex Husband' },
    { value: RelationshipType.ExSpouse, label: 'Ex Spouse' },
    { value: RelationshipType.ExWife, label: 'Ex Wife' },
    { value: RelationshipType.ExCommonLawPartner, label: 'Ex-Common-law partner' },
    { value: RelationshipType.Father, label: 'Father' },
    { value: RelationshipType.FatherInLaw, label: 'Father in Law' },
    { value: RelationshipType.FianceOrFiancee, label: 'Fiance/Fiancee' },
    { value: RelationshipType.Granddaughter, label: 'Granddaughter' },
    { value: RelationshipType.Grandfather, label: 'Grandfather' },
    { value: RelationshipType.Grandmother, label: 'Grandmother' },
    { value: RelationshipType.Grandson, label: 'Grandson' },
    { value: RelationshipType.HalfBrother, label: 'Half-brother' },
    { value: RelationshipType.HalfSister, label: 'Half-sister' },
    { value: RelationshipType.HostingFamily, label: 'Hosting Family' },
    { value: RelationshipType.Husband, label: 'Husband' },
    { value: RelationshipType.LawfulPartnerOrCoHabitant, label: 'Lawful Partner/Co-habitant' },
    { value: RelationshipType.LegalGuardian, label: 'Legal Guardian' },
    { value: RelationshipType.LegallyAdoptedChild, label: 'Legally adopted child' },
    { value: RelationshipType.Maid, label: 'Maid' },
    { value: RelationshipType.Mother, label: 'Mother' },
    { value: RelationshipType.MotherInLaw, label: 'Mother in Law' },
    { value: RelationshipType.Nephew, label: 'Nephew' },
    { value: RelationshipType.Niece, label: 'Niece' },
    { value: RelationshipType.Other, label: 'Other' },
    { value: RelationshipType.Parent, label: 'Parent' },
    { value: RelationshipType.Sibling, label: 'Sibling' },
    { value: RelationshipType.SignificantOther, label: 'Significant Other' },
    { value: RelationshipType.Sister, label: 'Sister' },
    { value: RelationshipType.SisterInLaw, label: 'Sister in Law' },
    { value: RelationshipType.Son, label: 'Son' },
    { value: RelationshipType.SonInLaw, label: 'Son in Law' },
    { value: RelationshipType.Spouse, label: 'Spouse' },
    { value: RelationshipType.Stepbrother, label: 'Stepbrother' },
    { value: RelationshipType.Stepchild, label: 'Stepchild' },
    { value: RelationshipType.Stepdaughter, label: 'Stepdaughter' },
    { value: RelationshipType.Stepfather, label: 'Stepfather' },
    { value: RelationshipType.Stepmother, label: 'Stepmother' },
    { value: RelationshipType.Stepsister, label: 'Stepsister' },
    { value: RelationshipType.Stepson, label: 'Stepson' },
    { value: RelationshipType.Uncle, label: 'Uncle' },
    { value: RelationshipType.Ward, label: 'Ward' },
    { value: RelationshipType.Wife, label: 'Wife' },
]
